export default __webpack_public_path__ + "static/media/CardPeak.258e86a8.svg";